import axios from 'axios'

import config from '../../config'

const updateUserProfile = (params = {}, data) => {
  const { airportId } = params

  const url = `${config.baseUrl}/${airportId}/AuthUsers/UpdateProfile`
  return axios.put(url, data)
}

export default updateUserProfile